import * as React from 'react'
import { ReactElement } from 'react'
import { InjuryPanelProps } from './FormContainer'
import { Field, Input } from '@fluentui/react-components'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'
import BaseCombobox from '../../Combobox/BaseCombobox'

type Props = InjuryPanelProps & {}

const DropdownOptions = ['Ja', 'Nee', 'Onbekend']
const TrafficType = ['Voetganger', 'Fietser', 'Passagier', 'Bestuurder Auto', 'Overig']

export default function TrafficAccidentPanel(props: Props): ReactElement {
    const themeClassName = useThemeClassName_unstable()
    return (
        <div className={props.styles.formRow}>
            <Field label="Kenteken tegenpartij" orientation={props.orientation}>
                <Input />
            </Field>
            <Field label="Gordel gedragen" orientation={props.orientation}>
                <BaseCombobox
                    listbox={{ className: themeClassName }}
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
            <Field label="Helm gedragen" orientation={props.orientation}>
                <BaseCombobox
                    listbox={{ className: themeClassName }}
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
            <Field label="Politie aanwezig" orientation={props.orientation}>
                <BaseCombobox
                    listbox={{ className: themeClassName }}
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
            <Field label="Soort deelnemer" orientation={props.orientation}>
                <BaseCombobox
                    listbox={{ className: themeClassName }}
                    entities={TrafficType}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
        </div>
    )
}
